<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { dateHelpers } from '@hfc/ui-core';
import { CalendlyEvent } from '@/consent/medicare/domain/CalendlyEventResponse';
import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';
import ScheduleAppointment from '@/shared/infrastructure/components/ScheduleAppointment.vue';
import { useMedicareConsentStore } from '@/consent/medicare/infrastructure/composition/useMedicareConsentStore';

const { medicareConsentStore, medicareConsentState } = useMedicareConsentStore();

const props = defineProps<{
  appointmentLink: () => string,
  recaptchaTokenRequired: boolean
}>();

defineExpose({
  sectionSubmit: () => true,
  sectionIsValid: async (): Promise<boolean> => Promise.resolve(true)
});

interface emitInterface {
  (event: 'prevSection'): void
  (event: 'hideNavigation'): void
  (event: 'submitConsent'): void
  (event: 'submitCalendlyInfo'): void
}

const emits = defineEmits<emitInterface>();
const { fromTimestampToFormatted } = dateHelpers();

const prefill = ref({
  customAnswers: {
    a1: medicareConsentState.value.application.contactInfo.zipCode?.toString(),
    a2: fromTimestampToFormatted(medicareConsentState.value.application.contactInfo.dateOfBirth, 'MM/DD/YYYY'),
  },
  firstName: medicareConsentState.value.application.contactInfo.firstName,
  lastName: medicareConsentState.value.application.contactInfo.lastName,
  email: medicareConsentState.value.application.contactInfo.email
});

const handleDateAndTimeSelected = ():void => {
  emits('submitConsent');
};

const handleEventScheduled = async (data: CalendlyEvent):Promise<void> => {
  await medicareConsentStore.saveEventData(data);
  emits('submitCalendlyInfo');
  emits('hideNavigation');
};

onBeforeMount(() => {
  if (props.recaptchaTokenRequired && !medicareConsentState.value.application.captcha_token) {
    emits('prevSection');
  }
});

</script>
<template>
  <BaseSection title="">
    <ScheduleAppointment :appointment-link="appointmentLink()" :prefill="prefill" :loading="medicareConsentState.isSubmittingCalendlyInfo" @date-and-time-selected="handleDateAndTimeSelected" @event-scheduled="handleEventScheduled" />
  </BaseSection>
</template>
